__turbopack_context__.v({
  "root": "button-module__AN-GYW__root",
});
